const fastGrowingOverview = [
  {
      "city": "Austin",
      "centiGrowth": "110",
      "millionaires": "32700",
      "centiMillionaires": "92",
      "billionaires": "10"
  },
  {
      "city": "Scottsdale",
      "centiGrowth": "102",
      "millionaires": "14500",
      "centiMillionaires": "63",
      "billionaires": "5"
  },
  {
      "city": "Palm Beach and West Palm Beach",
      "centiGrowth": "93",
      "millionaires": "10200",
      "centiMillionaires": "69",
      "billionaires": "9"
  },
  {
      "city": "Greenwich and Darien",
      "centiGrowth": "84",
      "millionaires": "12500",
      "centiMillionaires": "120",
      "billionaires": "10"
  },
  {
      "city": "The Bay Area",
      "centiGrowth": "82",
      "millionaires": "305700",
      "centiMillionaires": "675",
      "billionaires": "68"
  }
];


export {fastGrowingOverview};